import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import { common } from './../../../../../../data/constants';
import FilterWrapper from './../FilterWrapper';
import { useLanguage } from './../../../../../../context/LanguageContext';

class TextFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activityName: this.props.activityName
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ activityName: nextProps.activityName });
  }

  onCloseFilter = () => {
    this.props.updateLocalFilterPayload({
      activityName: this.state.activityName
    });
  };

  handleOnChange = event => {
    this.setState({ activityName: event.target.value });
  };

  render() {
    const filterWrapperProps = {
      changesInFilter: this.state.activityName ? 1 : 0,
      id: this.props.id,
      isUserAdded: this.props.isUserAdded,
      name: this.props.name,
      onCloseFilter: this.onCloseFilter,
      removeFilter: this.props.removeFilter
    };

    return (
      <FilterWrapper {...filterWrapperProps}>
        <TextField
          id='activityName'
          className='search-field'
          floatingLabelText={this.props.FILTER_BAR?.TEXT?.LABEL || ''}
          style={{ fontSize: '12px' }}
          value={this.state.activityName || ''}
          onChange={this.handleOnChange}
        />
      </FilterWrapper>
    );
  }
}

TextFilter.propTypes = {
  id: PropTypes.string.isRequired,
  isUserAdded: PropTypes.bool,
  name: PropTypes.string.isRequired,
  removeFilter: PropTypes.func,
  activityName: PropTypes.string,
  updateLocalFilterPayload: PropTypes.func.isRequired,
  FILTER_BAR: PropTypes.object
};

TextFilter.defaultProps = {
  isUserAdded: false,
  removeFilter: () => {},
  activityName: '',
  FILTER_BAR: {}
};

function TextFilterWrapper(props) {
  const { labels } = useLanguage();
  return <TextFilter {...props} FILTER_BAR={labels.FILTER_BAR} />;
}

export default TextFilterWrapper;
